import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { ReportData } from "../../models/report.model";
import { fromTask } from "@angular/fire/compat/storage";

@Component({
  selector: "app-report-table",
  templateUrl: "./report-table.component.html",
  styleUrls: ["./report-table.component.scss"]
})
export class ReportTableComponent implements OnInit {
  @Input() reportData: ReportData;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  dataSource: MatTableDataSource<any>;

  constructor() {
    this.dataSource = new MatTableDataSource<any>([]);
  }

  ngOnInit(): void {
    this.updateDataSource();
  }

  ngOnChanges(): void {
    this.updateDataSource();
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  updateDataSource(): void {
    this.dataSource.data = this.reportData.rows;
    this.dataSource.filterPredicate = (row, filter) => {
      return Object.values(row).some((cell: any) => {
        const val = cell?.value ?? cell;
        return String(val).toLowerCase().includes(filter);
      });
    };
  }

  applyFilter(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  getHeaderFields(): string[] {
    return this.reportData.headers.map(header => header.field);
  }
}
